<template>
  <div class="infobox-container" :class="{ 'is-opened': opened }">
    <div
      class="infobox-overlay"
      :class="{ visible: opened }"
      @click="closeInfobox()"
    ></div>
    <div id="infobox" class="infobox" :class="{ opened: opened }">
      <div class="menu-wrapper">
        <div class="head-block">
          <!-- Slider main container -->
          <div
            ref="swiper"
            class="swiper"
            :style="data.gallery != null ? 'display: block;' : 'display: none;'"
          >
            <!-- Additional required wrapper -->
            <div class="swiper-wrapper">
              <!-- Slides -->
              <div
                v-for="(image, index) in data.gallery"
                v-bind:key="index"
                class="swiper-slide"
              >
                <img :src="'/storage/' + image" />
              </div>
            </div>

            <!-- If we need navigation buttons -->
            <div class="swiper-button-prev"><img src="arrow-left.png" /></div>
            <div class="swiper-button-next"><img src="arrow-right.png" /></div>
          </div>

          <div v-if="data.image && data.gallery == null" class="infobox-image">
            <img :src="data.image" />
          </div>

          <div v-if="data.title" class="infobox-title">
            {{ data.title }}
          </div>

          <div v-if="data.text" class="infobox-text" v-html="data.text"></div>
        </div>

        <div class="close-menu">
          <img
            @click="closeInfobox()"
            src="https://passoni.com/themes/passoni/assets/images/icons/close-menu.svg"
            alt="Close menu"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation, Pagination } from "swiper";
import "swiper/swiper-bundle.min.css";
export default {
  name: "Infobox",
  props: ["data", "opened"],
  data() {
    return {};
  },
  mounted() {
    new Swiper(this.$refs.swiper, {
      // configure Swiper to use modules
      modules: [Navigation, Pagination],
      // Optional parameters
      loop: true,

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  },
  methods: {
    closeInfobox: function () {
      this.$emit("close-infobox", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-button-next,
.swiper-button-prev {
  &::after {
    display: none;
  }

  img {
    width: 20px;
  }
}

.swiper-wrapper {
  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 75%;
      margin: 0 auto;
    }
  }
}

.infobox-container {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  transform: translateX(100%);
  overflow: hidden;

  &.is-opened {
    transform: translateX(0);
  }
}

.infobox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  background: transparent;

  &.visible {
    z-index: 9999;
    background: rgba(0, 0, 0, 0.5);
  }
}

.infobox {
  background-color: white;
  position: absolute;
  width: 100%;
  min-height: 100vh;
  z-index: 99;
  right: -480px;
  max-width: 480px;
  transition: all 0.3s ease-in-out;
  z-index: 9999;
  overflow-y: auto;
  height: 100vh;

  &.opened {
    right: 0;
  }

  .infobox-image,
  .swiper {
    margin-bottom: 60px;
  }

  .infobox-image {
    img {
      width: 100%;
    }
  }

  .infobox-title {
    margin-bottom: 30px;
    font-family: FreightDispBookItalic;
    font-size: 20px;
  }

  .infobox-text {
  }

  .menu-wrapper {
    background-color: white;
    width: 80%;
    height: 100%;
    min-height: 100vh;
    margin: 0 auto;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 80px;

    .head-block {
      margin-top: 40px;

      ul {
        li {
          a {
            font-size: 12px;
            font-stretch: normal;
            letter-spacing: 1.92px;
            color: #000;
            text-transform: uppercase;
            font-weight: 500;
            text-decoration: none;
            position: relative;

            &:after {
              content: "";
              position: absolute;
              bottom: 0;
              left: 0;
              width: 0;
              height: 0.0625rem;
              background: #000;
              transition: all 0.3s ease-in-out;
            }

            &:hover {
              &:after {
                width: 100%;
              }
            }
          }
        }
      }
    }

    .close-menu {
      margin-bottom: 50px;
      width: 100%;
      cursor: auto;
      text-align: center;

      img {
        margin: 0 auto;
        width: 1.5625rem;
        transition: all 0.3s ease-in-out;
        cursor: pointer;
      }
    }

    ul {
      padding: 0;

      li {
        list-style: none;
        text-transform: uppercase;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
